export const More = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="22" viewBox="0 0 4 22" fill="none">
    <path d="M4 11C4 12.0959 3.09589 13 2 13C0.90411 13 0 12.0959 0 11C0 9.90411 0.90411 9 2 9C3.09589 9 4 9.90411 4 11Z" fill="#C1C1C1" />
    <path d="M4 20C4 21.0959 3.09589 22 2 22C0.90411 22 0 21.0959 0 20C0 18.9041 0.90411 18 2 18C3.09589 18 4 18.9041 4 20Z" fill="#C1C1C1" />
    <path d="M4 2C4 3.09589 3.09589 4 2 4C0.90411 4 0 3.09589 0 2C0 0.90411 0.90411 0 2 0C3.09589 0 4 0.90411 4 2Z" fill="#C1C1C1" />
  </svg>
);